const Util = {

	arrayEquals: function(a1, a2) {
		return a1.length==a2.length && a1.every(function(v,i) { return v === a2[i]});
	},

	compareOptions : function(opt1, opt2) {
		let vals1 = opt1.map((o) => {
			return o.value;
		});
		let vals2 = opt2.map((o) => {
			return o.value;
		});
		return Util.arrayEquals(vals1, vals2);
	},

	percentText: (val) => {
		if (!val) {
			return "0%";
		}
		return (val * 100).toFixed(0).toString() + "%";  
	},

};

export default Util;
